const cities = [
  { name: "Boynton Beach", zips: "33426, 33435, 33436, 33437" },
  { name: "Delray Beach", zips: "33444, 33445, 33446, 33483, 33484" },
  { name: "Lake Worth Beach", zips: "33460, 33461, 33462, 33463, 33467" },
  { name: "West Palm Beach", zips: "33401, 33405, 33407, 33409, 33411" },
  { name: "Boca Raton", zips: "33428, 33431, 33432, 33433, 33434" },
  { name: "Ocean Ridge", zips: "33435" },
  { name: "Gulf Stream", zips: "33483" },
  { name: "Lantana", zips: "33462, 33465" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function BoyntonBeachLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Boynton Beach &amp; Southern Palm Beach County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in downtown Boynton Beach, Ocean Ridge, Gulf Stream, or anywhere in southern Palm Beach County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Boynton Beach occupies one of the most picturesque stretches of Florida's Atlantic coastline, situated perfectly between the vibrant arts scene of Delray Beach to the north and the urban energy of West Palm Beach to the south. Founded in 1898 by Major Nathan Smith Boynton, a retired Civil War officer from Michigan who saw the potential in this sun-drenched stretch of sand and surf, the city has grown from a modest winter retreat into a thriving community of roughly 80,000 residents. Unlike its more famous neighbors, Boynton Beach has preserved a genuine small-town coastal character while developing world-class amenities that make it one of South Florida's most livable beach communities.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The city's crown jewel is Oceanfront Park, a pristine beachfront area that draws locals and visitors alike with its turquoise waters, clean sand, and family-friendly atmosphere. The Boynton Beach Harbor Marina serves as a gateway to the Intracoastal Waterway and the Atlantic Ocean, supporting a thriving boating and fishing culture that is central to the community's identity. The downtown Arts District along Ocean Avenue has emerged as a vibrant creative corridor, with murals, galleries, and the historic Schoolhouse Children's Museum anchoring a cultural renaissance that has transformed the city's image from sleepy beach town to dynamic coastal destination.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Boynton Beach's demographic profile is notably diverse and layered. The city includes established working-class neighborhoods, affluent waterfront communities along the Intracoastal, active adult communities that attract retirees from the Northeast and Midwest, and young families drawn by the excellent schools and coastal lifestyle. The Jewish community is well-represented, with several synagogues and cultural institutions serving residents who frequently travel to Israel for religious pilgrimages, family visits, and heritage tours. Hispanic and Caribbean communities add to the cultural richness, with family ties stretching across Latin America and the islands.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Geography positions Boynton Beach residents within easy reach of multiple transportation hubs. Palm Beach International Airport (PBI) sits just 15–20 minutes north via I-95, offering a refreshingly efficient alternative to the chaos of Miami International or Fort Lauderdale-Hollywood. Fort Lauderdale-Hollywood International Airport (FLL) is approximately 30–40 minutes south, providing additional flight options and budget carrier access. The Port of Palm Beach in nearby Riviera Beach offers Bahamas cruise departures on Margaritaville at Sea, while Port Everglades in Fort Lauderdale — one of the world's busiest cruise ports — is about 40–50 minutes south for major Caribbean itineraries.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The travel patterns of Boynton Beach residents reflect this diverse community. Snowbirds and retirees plan extended European tours, Mediterranean cruises, and visits to family in the Northeast and Canada. Young professionals commute to West Palm Beach, Boca Raton, and Fort Lauderdale for work in healthcare, finance, technology, and professional services — and frequently need passports for business travel to Latin America and Europe. Families with children at local schools plan spring break Caribbean cruises, summer trips to visit grandparents abroad, and Disney-then-international itineraries that require current passports for every family member.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            What makes Boynton Beach unique in the passport urgency landscape is its proximity to our Delray Beach office — roughly 10–15 minutes north via Federal Highway or I-95. For residents who prefer to drop off documents rather than ship them, this is the closest physical point of contact in our network. But like all our clients, Boynton Beach travelers typically start online, ship overnight from their home or office, and receive their completed passports within days. Whether you are a snowbird on Ocean Boulevard preparing for a Scandinavian cruise, a pharmaceutical rep in Quantum Park flying to Sao Paulo, or a parent on Hypoluxo Road coordinating a child's first passport for a family reunion in Colombia, Fast Passport Center understands the urgency and delivers results.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Boynton Beach — approximately 10–15 minutes north via Federal Highway or I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout southern Palm Beach County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in southern Palm Beach County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Delray Beach", href: "/delray-beach" },
                  { name: "West Palm Beach", href: "/west-palm-beach" },
                  { name: "Boca Raton", href: "/boca-raton" },
                  { name: "Palm Beach", href: "/palm-beach" },
                  { name: "Wellington", href: "/wellington" },
                  { name: "Naples", href: "/naples" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}